"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = 'M12 6C11.4477 6 11 6.44772 11 7V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V7C13 6.44772 12.5523 6 12 6Z M11 17.0039V16.9961C11 16.446 11.4477 16 12 16C12.5523 16 13 16.446 13 16.9961V17.0039C13 17.554 12.5523 18 12 18C11.4477 18 11 17.554 11 17.0039Z';